'use client'
import Page from '~/containers/Views/Common/Terms';

export default Page;
